exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-1c33d55c], h4[data-v-1c33d55c], h5[data-v-1c33d55c] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
